import mediator, { MediatorRequestWithResponse } from '../utilities/mediator';
import { urls } from '../utilities/dataHelpers';
import { ApiEndpoints } from 'adc-sirius-module-common';

type AboutResponse = Record<string, string>;

const handleGetAbout = (
  request: MediatorRequestWithResponse<AboutResponse>,
) => {
  request.response = new Promise<AboutResponse>((resolve, reject) => {
    mediator
      .request<AboutResponse>('api:invoke' as string, {
        method: ApiEndpoints.EP_SYSTEM_ABOUT.Method,
        url: urls.api + ApiEndpoints.EP_SYSTEM_ABOUT.Path,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

mediator.subscribe('system:getAbout', handleGetAbout);
